<script>
import TitleBanners from "./Main/TitleBanners.vue";
import OurServices from "./Main/OurServices.vue";
import FaqWork from "./Main/FaqWork.vue";
import ProjectsLine from "./Other/ProjectsLine.vue";
import OnlineForm from "./Other/OnlineForm.vue";
import ReviewsBlock from "./Main/ReviewsBlock.vue";
import FaqQues from "./Other/FaqQues.vue";
import BtnApplication from "./Other/BtnApplication.vue";
import gsap from "gsap";
import {ensureSanctumSession, notifyMiniAppReady} from "../miniAppAjax.js";



export default {
  inject: ["gsap"],
  name: "Main",
  components: {
    BtnApplication,
    FaqQues,
    ReviewsBlock,
    OnlineForm,
    ProjectsLine,
    FaqWork,
    OurServices,
    TitleBanners,
  },
  data() {
    return {
      servicesLocal: [

        {
          'tarif' : 'Инвестиция',
          'img' : 'services1.png',
          'desc' : 'Предлагаем услуги по подбору и покупке ликвидного объекта  недвижимости и последующим управлением с целью увеличения финансового состояния.',
          'color_line1' : "blue",
          'color_line2' : "blue",
          'route' : '/investition',
          'filter' : "",
        },
        {
          'tarif' : 'Управление',
          'img' : 'services3.png',
          'desc' : 'Предлагаем услуги по подготовке\n' +
              'объекта недвижимости к аренде с учетом эстетических и\n' +
              'маркетинговых принципов,\n' +
              'увеличивая арендную стоимость и экономя Ваше время.',
          'route' : '/management',
          'color_line1' : "blue",
          'color_line2' : "blue",
          'filter' : "",
        },
        {
          'tarif' : 'Реинвестиция',
          'img' : 'services2.png',
          'desc' : 'Предлагаем услуги по продаже\n' +
              'имеющего объекта недвижимости\n' +
              'с последующей покупкой более\n' +
              'ликвидного объекта и\n' +
              'дальнейшим его управлением.',
          'route' : '/reinvestition',
          'color_line1' : "orange",
          'color_line2' : "green",
          'filter' : "",
        },
        {
          'tarif' : 'Хоумстейджинг',
          'img' : 'services4.png',
          'desc' : 'Мы преображаем интерьер,\n' +
              'так, чтобы потенциальные арендаторы\n' +
              'и покупатели в него влюбились.\n' +
              'Это поможет сдать и продать объект\n' +
              'быстро и по более высокой цене.',
          'route' : '/home',
          'color_line1' : "orange",
          'color_line2' : "green",
          'filter' : "home",
        },
        {
          'tarif' : 'Ремонт',
          'img' : 'services5.png',
          'desc' : 'Осуществляем полный комплекс\n' +
              'услуг по ремонту объекта недвижимости,\n' +
              'начиная от разработки\n' +
              'дизайн-проекта и заканчивая\n' +
              'мебелировкой помещений.',
          'route' : '/home',
          'color_line1' : "orange",
          'color_line2' : "green",
          'filter' : "repair",
        }
      ],
      workLocal:[
        {
          'title' : 'Выбор услуги',
          'desc' : 'Ознакомьтесь с услугами, которые оказывает наша организация, и выберите интересующую именно Вас. Оставьте заявку на сайте и мы перезвоним.',
          'color' : 'blue',
          "mobile_uniq" : false,
        },
        {
          'title' : 'Консультация',
          'desc' : 'Специалисты нашей компании проведут профессиональную консультацию, проговорят все мероприятия, которые включают данную услугу, сделают предварительный анализ исходных данных. После того, как будут достигнуты понимание и готовность к дальнейшему сотрудничеству, заключаем договор.',
          'color' : 'lite-blue',
          "mobile_uniq" : false,
        },
        {
          'title' : 'Заключение договора',
          'desc' : 'Осуществляется выезд нашего специалиста либо приглашаем Вас в наш офис для заключения договора. Далее мы начинаем работать.',
          'color' : 'green',
          "mobile_uniq" : false,
        },
      ],
      reviews:[
        {
          'avatar' : 'pony.webp',
          'name' : 'Alexander A. M.',
          'category' : 'инвестиции',
          'date' : '03.03.25',
          'message' : 'Прекрасные партнеры для хозяев апартаментов и квартир. Оперативно отремонтировали нам апартаменты, все с нами согласовали, решили все возникшие проблемы с застройщиком, управляющей компанией и коммунальными службами без необходимости личного присутствия хозяев. Быстро и точно предоставляют отчетность, напоминают о необходимых действиях, вы всегда знаете, чего ожидать.\n',

        },
        {
          'avatar' : 'rob.webp',
          'name' : 'Наталья К.',
          'category' : 'инвестиции',
          'date' : '10.12.24',
          'message' : 'Хочу поблагодарить команду «Бизнес Аренда» за профессиональный подход к своему делу. За четкую организацию процесса сдачи жилья, сопровождение клиентов, готовность незамедлительно решать возникшие вопросы, в том числе и нестандартные ситуации. Работаю с «Бизнес Арендой» уже третий год как инвестор жилья и не знаю проблем, все вопросы команда взяла на себя, что очень ценно. Рекомендую данного поставщика услуг, желаю ребятам роста и успехов в их профессиональном деле.',

        },
        {
          'avatar' : 'hat-student.webp',
          'name' : 'Екатерина В.',
          'category' : 'инвестиции',
          'date' : '26.07.24',
          'message' : 'По рекомендации близкого друга вышла на этих ребят, решила через них сдать квартиру в спальном районе у МКАДа, так как устала сама решать все вопросы по сдаче, эти звонки, показы и проч.. В итоге после детального обсуждения мне предложили продать эту трешку у МКАда и на эти средства купить студию в бетоне в пределах ТТК, долго думали и решили в итоге попробовать. Тем более, что за ремонт в студии взялись эти же ребята на оставшиеся с продажи деньги. На протяжении всего времени был доступ к видео хода ремонта, все отчеты, финансы прозрачно. В итоге -современный дизайн и студия "ушла" в аренду сразу же на долгий срок за очень приличные деньги. Денег приносит больше, чем старая трёшка у МКАД и все вопросы по управлению решают эти ребята. В общем все гут, можно иметь дело.',

        },
      ],
      slider:[
        {
          'avatar' : 'pony.webp',
          'name' : 'Alexander A.',
          'category' : 'инвестиции',
          'date' : '03.03.25',
          'message' : 'Прекрасные партнеры для хозяев апартаментов и квартир. Оперативно отремонтировали нам апартаменты, все с нами согласовали, решили все возникшие проблемы с застройщиком, управляющей компанией и коммунальными службами без необходимости личного присутствия хозяев. Быстро и точно предоставляют отчетность, напоминают о необходимых действиях, вы всегда знаете, чего ожидать.\n',
        },
        {
          'avatar' : 'rock.webp',
          'name' : 'Юлия',
          'category' : 'инвестиции',
          'date' : '07.03.25',
          'message' : 'Заезжали по адресу : ЖК Лайнер Запад.\n' +
              'Апартаменты понравились ! Очень удобное местоположенте : рядом находится тц ,в котором можно купить все необходимое ,в самом жк также есть магазины,салоны красоты ,стоматолигии,аптеки и прочее . Вообщем,все в шаговой доступности ,что очень круто 🤓\n' +
              '\n' +
              'Рядом есть метро - от которого можно доехать без проблем в любую точку!\n' +
              '\n' +
              'Сами апарты очень уютные : есть телевизор ,кондиционер , стиральная машина-сушилка ; ремонт выполнен современно в светлых тонах.Достаточно тихо ,нет никакой суматохи по ночам\n' +
              '\n' +
              'Арендодатели постоянно на связи ,отвечали на все вопросы !\n' +
              '\n' +
              'Также при заезде мы выбрали услугу с клинингом раз в месяц - что очень оказалочь очень удобным !\n' +
              '\n' +
              'Однозначно рекомендую💗',
        },
        {
          'avatar' : 'bunny.webp',
          'name' : 'Дарья Г.',
          'category' : 'инвестиции',
          'date' : '12.12.24',
          'message' : 'Очень классная команда! Ответственные, честные и приятные. Была необходимость срочно квартира на месяц в связи с переездом, оперативно показали, завезли все необходимы принадлежности, учли пожелания по дополнительной обстановке квартиры, были на связи всегда!) жила в сердце столице с большим удовольствием. Обязательно буду обращаться к ним, так как все комфортно, быстро и надежно 🫶🏽',
        },
        {
          'avatar' : 'review-kitty.webp',
          'name' : 'Анна',
          'category' : 'инвестиции',
          'date' : '22.01.25',
          'message' : 'Жила полгода на Спартаке в чудесной уютной евродвушке, которую арендовала через Бизнес Аренду.\n' +
              '\n' +
              'Это были счастливые и спокойные месяцы, так как жить в апартах было очень комфортно, а все вопросы решались очень оперативно(а их было не много, так как квартира продумана до мелочей), взаимодействие с УК было максимально приятным, всегда знаешь, что тебе помогут и есть к кому обратиться\n' +
              '\n' +
              'Удобно, что жилье можно снять помесячно, это огромный плюс для людей, кто не ведь год живет в Москве. Благодарю всю команду за любовь к клиентам и свое дело! Желаю процветания!',
        },
        {
          'avatar' : 'hat-student.webp',
          'name' : 'Балконский',
          'category' : 'инвестиции',
          'date' : '22.01.25',
          'message' : 'Снимал у этой компании квартиру в ЖК Тринити. Прекрасный минималистичный интерьер в светлых тонах, удобный ортопедический матрас, бытовая техника отличная! Удобно, что есть свой мастер и клининг. Менеджер по работе с арендаторами приятная девушка, всегда на связи и готова помочь. Вернусь ещё, как буду в Москве. Мне понравилось!',
        },
        {
          'avatar' : 'croco.webp',
          'name' : 'Aleksey Ch.',
          'category' : 'инвестиции',
          'date' : '1.12.24',
          'message' : 'Хочу оставить только положительные отзывы и порекомендовать Александру и его партнерам. Все квартиры сделаны с очень хорошим, качественным ремонтом, надежной техникой. Квартиры чистые, приятно находиться в данных пространствах. Так же что очень важно что собственники являются честными и отзывчивыми людьми, с которыми приятно вести общение.',
        },
        {
          'avatar' : 'hat-student.webp',
          'name' : 'Юлия С.',
          'category' : 'инвестиции',
          'date' : '5.12.24',
          'message' : 'В Сердце Столицы с удовольствием живу уже 2 год. Безупречный дизайн апартаментов, продуманный до мелочей. Очень чуткое руководство! Отзывчивый персонал, на любые просьбы и вопросы самые быстрые ответы и предложения. Спасибо вам огромное за внимание и заботу!',
        },
        {
          'avatar' : 'bunny.webp',
          'name' : 'Ольга Ч.',
          'category' : 'инвестиции',
          'date' : '8.10.24',
          'message' : 'Хотела поблагодарить сотрудников Бизнес Аренды за качественный сервис, клиентоориентированность , красивый интерьер. Очень комфортно взаимодействовать, вежливое и внимательное отношение к клиентам. Я проживала в жк Движение Тушино 5 месяцев. Рядом с м Спартак. Всё новенькое, красивый дизайн, качественный ремонт.',
        },
      ],
      faqList:[
        {
          "title": "Как заключается договор с собственником квартиры?",
          "desc" : "Мы заключаем с договор аренды на 11 мес. и далее уже можем его продлить. Договор заключается с нашей компанией, которая будет является арендатором. Квартиры мы сдаем по договору субаренды на основании заключенного договора аренды с вами как с собственником."
        },
        {
          "title": "Из каких этапов состоит пакет \"Инвестиция\"?",
          "desc" : "<span>\n" +
              "            Пакет “Инвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Из каких этапов состоит пакет \"Реинвестиция\"?",
          "desc" : "<span>\n" +
              "            Пакет Реинвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Продажа текущего объекта недвижимости</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Что такое хоумстейджинг?",
          "desc" : "С английского хоумстейджинг переводится как «домашняя постановка». По сути, это подготовка квартиры, в основе которой лежат дизайнерские и психологические приемы. Применяется, чтобы продать или сдать объект быстро и по более высокой цене"
        },
        {
          "title": "Какие сроки оказания услуг?",
          "desc" : "Срок оказания услуг зависит от выбранного пакета. Обычно мы подписываем договор на 3 месяца, однако по нашей практике этот срок составляет до 45 дней."
        },
        {
          "title": "Из каких этапов состоит пакет \"Управление\"?",
          "desc" : "<span>\n" +
              "            Пакет “Управление” состоит из следующих этапов:\n" +
              "         </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Хоумстейджинг объекта недвижимости</li>\n" +
              "            <li>Продвижение объекта недвижимости</li>\n" +
              "            <li>Ведение объекта недвижимости</li>\n" +
              "          </ul>"
        }
      ]
    }
  },
  methods:{
    async auth(){
      const tg = typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp
      const maxApp = typeof window !== 'undefined' && window.WebApp

      let mini_app_provider = null
      let userData = ''

      const fmtAxiosErr = (error) => {
        let s = (error && error.message) ? error.message : String(error)
        if (error && error.response) {
          s += '\nHTTP ' + error.response.status
          const d = error.response.data
          if (d !== undefined) {
            s += '\n' + (typeof d === 'string' ? d : JSON.stringify(d))
          }
        }
        return s
      }

      if (tg && tg.initData) {
        mini_app_provider = 'telegram'
        userData = tg.initData
        tg.setHeaderColor('#202442')
        tg.expand()
      } else if (maxApp && maxApp.initData) {
        mini_app_provider = 'max'
        userData = maxApp.initData
      } else {
        const diag = [
          '[MiniApp] Нет initData — логин не отправлен.',
          'Telegram.WebApp: ' + (tg ? 'да' : 'нет'),
          'Telegram initData длина: ' + (tg && tg.initData ? tg.initData.length : 0),
          'MAX window.WebApp: ' + (maxApp ? 'да' : 'нет'),
          'MAX initData длина: ' + (maxApp && maxApp.initData ? maxApp.initData.length : 0),
          maxApp && maxApp.platform ? 'MAX platform: ' + maxApp.platform : ''
        ].filter(Boolean).join('\n')
        console.warn(diag)
        if (this.$router && this.$route.path !== '/') {
          void this.$router.push({ path: '/' })
        }
        return
      }

      notifyMiniAppReady()
      await ensureSanctumSession(this.axios)

      this.axios.post('/api/login', {
        telegram_user: userData,
        mini_app_provider: mini_app_provider
      })
          .then(response => {
              if (response.data.success) {
                  this.getUser(response.data.data || null);
              } else {
                  const msg = (response.data && response.data.message) ? response.data.message : 'Ошибка аутентификации'
                  console.warn('[api/login] success=false', { mini_app_provider, msg })
                  if (typeof window.Alerts !== 'undefined') {
                    window.Alerts.error(msg, 'topRight', false)
                  }
              }
          })
          .catch(function (error) {
              const detail = fmtAxiosErr(error)
              console.error(error)
              console.warn('[api/login] ошибка запроса', mini_app_provider, detail)
              if (typeof window.Alerts !== 'undefined') {
                window.Alerts.error(detail.split('\n')[0] || 'Ошибка запроса авторизации', 'topRight', false)
              }
          });
    },
    getUser(fallbackUser = null){
      setTimeout(() => {

      this.axios.get('/api/user')
        .then(response => {
            const data = response.data.data ?? fallbackUser
            if (!data) {
              console.warn('[getUser] нет данных пользователя (сессия и ответ логина пусты по user)')
              return
            }
            this.setUser(data)
            this.setBalance(data.balance);
            this.setAuth();

            this.setNotiList(data.noti_list);
            this.setProfileAnon(data.users_flag ? data.users_flag.is_anon : false);
            this.balanceSock = this.centrifuge.newSubscription('public:balance#' + data.id)
            this.balanceSock.subscribe();
            this.balanceSock.on('publication', (message) => {
                this.setBalance(message.data.balance);
            });

            this.messageSock = this.centrifuge.newSubscription('public:messages#' + data.id)
            this.messageSock.subscribe();
            this.messageSock.on('publication', (message) => {
                if(message.data.type == 1){
                    Alerts.success(message.data.message);
                }
                if(message.data.type == 2){
                    Alerts.error(message.data.message);
                }
                if(message.data.type == 3){
                    Alerts.info(message.data.message);
                }
            });


        })
        .catch(function (error) {
            // Alerts.error('Произошла ошибка! Обратитесь в тех. поддержку!')
            console.error(error);
        });
      }, 3000);
    },
  },
  mounted() {
  }
}
</script>

<template>
  <div class="wrapper-content main" id="main">
    <title-banners></title-banners>
    <our-services
        :services="servicesLocal"></our-services>
    <faq-work
        title="Как Мы Работаем?"
        :work="workLocal"></faq-work>
    <projects-line></projects-line>
    <online-form></online-form>
    <faq-ques
      :faqlist="faqList"
    ></faq-ques>
    <reviews-block
    :reviews="reviews" :slider="slider"></reviews-block>
    <btn-application></btn-application>
  </div>

</template>

<style scoped>

</style>